import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import apiService from '../services/api';
import { authHref, useSchoolBrand } from '../auth/schoolLink';
import {
  AuthScreen,
  BrandHeader,
  PasswordField,
  fieldText,
} from '../components/AuthChrome';
import '../styles/AuthScreen.css';

const ResetPassword = () => {
  const brand = useSchoolBrand();
  const [searchParams] = useSearchParams();
  const [uid, setUid] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let paramUid = searchParams.get('uid');
    let paramToken = searchParams.get('token');
    if (!paramUid || !paramToken) {
      const urlParams = new URLSearchParams(window.location.href.split('?')[1] || '');
      paramUid = paramUid || urlParams.get('uid');
      paramToken = paramToken || urlParams.get('token');
    }
    if (paramUid) setUid(paramUid);
    if (paramToken) setToken(paramToken);
  }, [searchParams]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (password.length < 8) nextErrors.password = 'Use at least 8 characters.';
    if (password !== confirmPassword) nextErrors.confirm = 'Passwords do not match.';
    if (!uid || !token) nextErrors.general = 'Invalid or expired reset link. Please request a new one.';
    if (Object.keys(nextErrors).length) {
      setErrors(nextErrors);
      return;
    }

    setLoading(true);
    setErrors({});
    try {
      await apiService.resetPassword({
        uid,
        token,
        new_password: password,
      });
      setDone(true);
    } catch (error) {
      const data = error.response?.data;
      if (data && typeof data === 'object') {
        setErrors({
          general: fieldText(data.token) || fieldText(data.detail) || fieldText(data.non_field_errors),
          password: fieldText(data.new_password),
        });
        if (!fieldText(data.token) && !fieldText(data.detail) && !fieldText(data.new_password) && !fieldText(data.non_field_errors)) {
          setErrors({ general: 'Invalid or expired link. Please request a new password reset.' });
        }
      } else {
        setErrors({ general: 'Something went wrong. Please try again or request a new link.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthScreen brand={brand}>
      <BrandHeader brand={brand} />
      <h1 className="auth-title">{done ? 'Password updated' : 'Set a new password'}</h1>
      <p className="auth-subtitle">
        {done
          ? 'You can sign in with your new password.'
          : 'Choose a new password for your account.'}
      </p>

      {errors.general ? <div className="auth-alert">{errors.general}</div> : null}

      {done ? (
        <Link className="auth-submit auth-submit-link" to={authHref('/login', brand.schoolId)}>
          Log in
        </Link>
      ) : (
        <form onSubmit={handleSubmit}>
          <PasswordField
            id="reset-password"
            label="New password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Password"
            autoComplete="new-password"
            error={errors.password}
            hint="Use at least 8 characters"
          />
          <PasswordField
            id="reset-confirm"
            label="Confirm password"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            placeholder="Password"
            autoComplete="new-password"
            error={errors.confirm}
          />
          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Saving…' : 'Reset password'}
          </button>
        </form>
      )}

      {done ? null : (
        <p className="auth-footer">
          <Link to={authHref('/forgot-password', brand.schoolId)}>Request a new link</Link>
        </p>
      )}
    </AuthScreen>
  );
};

export default ResetPassword;
